function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { CurrencyInput } from "../../../helperComponents";
import { formatValue, getSeparatorByCurrency } from "../../../utils/currency";

var PrimaForm = function PrimaForm(props) {
  var _polizaEndorsementFor, _polizaEndorsementFor2, _poliza$broker_inform, _polizaEndorsementFor3, _polizaEndorsementFor4, _poliza$broker_inform2, _polizaEndorsementFor5, _polizaEndorsementFor6, _polizaEndorsementFor7, _polizaEndorsementFor8, _polizaEndorsementFor9, _polizaEndorsementFor10;

  var _props$canModify = props.canModify,
      canModify = _props$canModify === void 0 ? false : _props$canModify,
      _props$isDefaultOverr = props.isDefaultOverrideActive,
      isDefaultOverrideActive = _props$isDefaultOverr === void 0 ? false : _props$isDefaultOverr,
      _props$forceNegative = props.forceNegative,
      forceNegative = _props$forceNegative === void 0 ? false : _props$forceNegative,
      poliza = props.poliza,
      polizaEndorsementForm = props.polizaEndorsementForm,
      onChangeAmount = props.onChangeAmount;

  var transformSignNumber = function transformSignNumber(value) {
    return forceNegative ? -value : value;
  };

  var currencyFormat = getSeparatorByCurrency(poliza.currency);

  var _React$useState = React.useState(isDefaultOverrideActive),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      manualOverride = _React$useState2[0],
      setManualOverride = _React$useState2[1];

  var isPrimaDisabled = !canModify || !manualOverride;
  return /*#__PURE__*/React.createElement(React.Fragment, null, canModify && /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onChange: function onChange() {
      return setManualOverride(!manualOverride);
    },
    checked: manualOverride
  }), "Ingresar prima manualmente")))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Prima neta afecta endoso"), isPrimaDisabled && /*#__PURE__*/React.createElement("input", {
    type: "text",
    disabled: true,
    value: "".concat(currencyFormat.currency, " ").concat((polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : polizaEndorsementForm.affects_net_bonus) || 0),
    className: "form-control"
  }), !isPrimaDisabled && /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    defaultValue: (polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : polizaEndorsementForm.affects_net_bonus) || 0,
    currency: currencyFormat.currency,
    onValueChange: function onValueChange(value) {
      onChangeAmount({
        affects_net_bonus: formatValue(transformSignNumber(value), currencyFormat.decimalLimit)
      });
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Nueva Prima neta afecta"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    value: ((_polizaEndorsementFor = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor === void 0 ? void 0 : (_polizaEndorsementFor2 = _polizaEndorsementFor.commission) === null || _polizaEndorsementFor2 === void 0 ? void 0 : _polizaEndorsementFor2.affects_net_bonus) || (poliza === null || poliza === void 0 ? void 0 : (_poliza$broker_inform = poliza.broker_information) === null || _poliza$broker_inform === void 0 ? void 0 : _poliza$broker_inform.affects_net_bonus),
    currency: currencyFormat.currency,
    disabled: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Prima neta exenta endoso"), isPrimaDisabled && /*#__PURE__*/React.createElement("input", {
    type: "text",
    disabled: true,
    value: "".concat(currencyFormat.currency, " ").concat(polizaEndorsementForm.exempt_net_bonus || 0 || 0),
    className: "form-control"
  }), !isPrimaDisabled && /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    defaultValue: polizaEndorsementForm.exempt_net_bonus || 0,
    currency: currencyFormat.currency,
    disabled: isPrimaDisabled,
    onValueChange: function onValueChange(value) {
      onChangeAmount({
        exempt_net_bonus: formatValue(transformSignNumber(value), currencyFormat.decimalLimit)
      });
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Nueva Prima neta exenta"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    value: ((_polizaEndorsementFor3 = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor3 === void 0 ? void 0 : (_polizaEndorsementFor4 = _polizaEndorsementFor3.commission) === null || _polizaEndorsementFor4 === void 0 ? void 0 : _polizaEndorsementFor4.exempt_net_bonus) || (poliza === null || poliza === void 0 ? void 0 : (_poliza$broker_inform2 = poliza.broker_information) === null || _poliza$broker_inform2 === void 0 ? void 0 : _poliza$broker_inform2.exempt_net_bonus),
    currency: currencyFormat.currency,
    disabled: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Prima neta endoso"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    value: polizaEndorsementForm.net_bonus || 0,
    currency: currencyFormat.currency,
    disabled: true
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Nueva Prima neta"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    value: ((_polizaEndorsementFor5 = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor5 === void 0 ? void 0 : (_polizaEndorsementFor6 = _polizaEndorsementFor5.commission) === null || _polizaEndorsementFor6 === void 0 ? void 0 : _polizaEndorsementFor6.net_bonus) || 0,
    currency: currencyFormat.currency,
    disabled: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "IVA endoso"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    value: polizaEndorsementForm.iva || 0,
    currency: currencyFormat.currency,
    disabled: true
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Nuevo IVA"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    value: ((_polizaEndorsementFor7 = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor7 === void 0 ? void 0 : (_polizaEndorsementFor8 = _polizaEndorsementFor7.commission) === null || _polizaEndorsementFor8 === void 0 ? void 0 : _polizaEndorsementFor8.iva) || 0,
    currency: currencyFormat.currency,
    disabled: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Prima total endoso"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    value: polizaEndorsementForm.total_bonus || 0,
    currency: currencyFormat.currency,
    disabled: true
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Nueva prima total"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    value: ((_polizaEndorsementFor9 = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor9 === void 0 ? void 0 : (_polizaEndorsementFor10 = _polizaEndorsementFor9.commission) === null || _polizaEndorsementFor10 === void 0 ? void 0 : _polizaEndorsementFor10.total_bonus) || 0,
    currency: currencyFormat.currency,
    disabled: true
  }))));
};

export default PrimaForm;